// initialize rollbar as early as possible so it can catch errors in setup
import './util/rollbar';
import 'inobounce';

import { render } from 'react-dom';
import context from './util/context';
import store from './store';
import history from './history';
import { routes } from './routes';

render(routes({ store, history }), context.document.getElementById('mount'));



// WEBPACK FOOTER //
// ./js/configure.js